import {useEffect} from 'react';
import {metrics} from '@opentelemetry/api';
import type {Metric} from 'web-vitals';
import {onCLS, onFCP, onINP, onLCP, onTTFB} from 'web-vitals';

// records Core Web Vitals (LCP, CLS, INP, FCP, TTFB) as OTEL histogram metrics.
// requires a MeterProvider to be registered globally before this hook runs —
// BrowserOtelProvider handles that via ensureProviders().
export const useOpenTelemetryWebVitals = () => {
  useEffect(() => {
    const meter = metrics.getMeter('web-vitals');

    const histograms: Record<
      string,
      ReturnType<typeof meter.createHistogram>
    > = {
      CLS: meter.createHistogram('web_vital.cls', {
        description: 'Cumulative Layout Shift',
      }),
      FCP: meter.createHistogram('web_vital.fcp', {
        description: 'First Contentful Paint',
        unit: 'ms',
      }),
      INP: meter.createHistogram('web_vital.inp', {
        description: 'Interaction to Next Paint',
        unit: 'ms',
      }),
      LCP: meter.createHistogram('web_vital.lcp', {
        description: 'Largest Contentful Paint',
        unit: 'ms',
      }),
      TTFB: meter.createHistogram('web_vital.ttfb', {
        description: 'Time to First Byte',
        unit: 'ms',
      }),
    };

    const recordMetric = (metric: Metric) => {
      histograms[metric.name]?.record(metric.value, {
        rating: metric.rating,
        navigation_type: metric.navigationType,
      });
    };

    onCLS(recordMetric);
    onFCP(recordMetric);
    onINP(recordMetric);
    onLCP(recordMetric);
    onTTFB(recordMetric);
  }, []);
};
